import { render, staticRenderFns } from "./OfertaForm.vue?vue&type=template&id=1ac703a9&scoped=true&"
import script from "./OfertaForm.vue?vue&type=script&lang=js&"
export * from "./OfertaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac703a9",
  null
  
)

export default component.exports